/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 04.08.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import BaseController from "./BaseController";

import {NotFoundException} from "../../../Exceptions";

/**
 * Class for viewing subresource data of parent resource.
 */
class SubviewController extends BaseController {
    static propTypes = {
        basePath: PropTypes.string.isRequired,
        params: PropTypes.shape({
            path: PropTypes.string.isRequired,
            resource: PropTypes.string.isRequired,
            action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
            id: PropTypes.string,
            query: PropTypes.object,
            tab: PropTypes.string,
            parentPath: PropTypes.string,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentId: PropTypes.string,
            parentField: PropTypes.string,
            parentTab: PropTypes.string,
            isModal: PropTypes.bool
        }).isRequired,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired
    };

    static defaultProps = {};

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.resource != this.props.resource || prevProps.id != this.props.id) this.loadData();
    }

    loadData() {
        this.loadResource();
    }

    loadResource() {
        if (!this.getParentResourceBuffer()) return;

        // Load data from parent resource object:
        let rec = this.getParentResourceFieldRecord();
        if (rec == null) throw new NotFoundException();

        this.actions().setCurrentRecord.defer(rec);
    }

    getActionData(a) {
        if (this.state.parentResource)
            return this.state.parentResource.currentRecord;
        return null;
    }

    loadingFinished(key, newState, oldState) {
        if (key === "parentResource" && this.getParentResourceBuffer(newState) !== this.getParentResourceBuffer(oldState)) this.loadResource();
    }

    /**
     * Called when specified store loading state is not changed by there were some changes
     * in store data.
     * @param {string} key
     * @param {BaseRestStoreState} newState Store new state
     * @param {BaseRestStoreState} oldState Store old state
     */
    storeChanged(key, newState, oldState) {
        if (key === "parentResource" && this.getParentResourceBuffer(newState) !== this.getParentResourceBuffer(oldState)) this.loadResource();
    }

    getParentResourceBuffer(state) {
        if (!state) state = this.state.parentResource;
        return state.currentRecord;
    }

    getParentResourceFieldRecord() {
        let buffer = this.getParentResourceBuffer();
        if (!buffer) return null;
        let rec = buffer[this.props.params.parentField];
        if (!rec || !rec.items) return null;

        return _.findWhere(rec.items, {clientId: this.props.params.id});
    }
}

export default SubviewController;
